<template>
  <div>
    <div class="az_overview_tb_bx">
      <table class="az_overview_tb">
        <thead>
        <tr>
          <td>{{ $t('repoerts.tasksName') }}</td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{$t('TOTALTASKS')}}</td>
          <td>{{ projectDataList.taskCount }}</td>
        </tr>
        <tr>
          <td>{{$t('ACTIVETASKS')}}</td>
          <td>{{ projectDataList.activeTasks }}</td>
        </tr>
        <tr>
          <td>{{$t('SUCCESSFULTASKS')}}</td>
          <td>{{ projectDataList.successTasks }}</td>
        </tr>
        <tr style="color: #ff0000">
          <td>{{$t('EXPIREDTASKS')}}</td>
          <td>{{ projectDataList.expiredTasks }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="chartOptions.xaxis.categories.length > 0" class="az_overview_chart_kan">
      <vue-apex-charts :key="chartKey" :options="chartOptions" :series="series" type="bar" width="100%"/>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'


export default {
  name: "TypeKanbanProject",
  components: {
    VueApexCharts,
  },
  data: () => ({
    projectDataList: [],
    pagination: {
      count: 0,
      page: 0,
      range: 5,
    },
    inputPage: 1,


    series: [
      {
        name: 'New',
        data: []
      },
      {
        name: 'Doing',
        data: []
      },
      {
        name: 'Verify',
        data: []
      },
      {
        name: 'Done',
        data: []
      },
      {
        name: 'Archive',
        data: []
      },
    ],
    chartOptions: {
      colors: ['#64D0DA', '#877BEB', '#EA4A66', '#FE7297', '#FFC65B'],
      xaxis: {
        categories: [],
      },
      chart: {
        type: 'bar',
        stacked: true,
      },
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'center',
          }
        },
      },
    },
    chartKey: 0,
  }),
  computed: {
    computedLastPage() {
      return this.pagination.count > 0 ? Math.ceil(this.pagination.count / this.pagination.range) - 1 : 0;
    },
    computedItemFrom() {
      return (this.pagination.range * this.pagination.page) + 1;
    },
    computedItemTo() {
      return (this.pagination.range * this.inputPage) < this.pagination.count ? (this.pagination.range * this.inputPage) : this.pagination.count;
    },
  },
  watch: {
    'pagination.range'() {
      this.GetProjectAll();
    },
    'projectDataList'() {
      let tempName = [], tempNew = [], tempDoing = [], tempVerify = [], tempDone = [], tempArchive = [];

      this.projectDataList.forEach(item => {
        tempName.push(item.projectName);
        tempNew.push(item.reportDtos.NEW);
        tempDoing.push(item.reportDtos.DOING);
        tempVerify.push(item.reportDtos.VERIFY);
        tempDone.push(item.reportDtos.DONE);
        tempArchive.push(item.reportDtos.ARCHIVE);
      });


      this.chartOptions.xaxis.categories = tempName;
      this.series[0].data = tempNew;
      this.series[1].data = tempDoing;
      this.series[2].data = tempVerify;
      this.series[3].data = tempDone;
      this.series[4].data = tempArchive;

      this.chartKey++;
    },
  },
  created() {
    this.GetProjectAll();
  },
  methods: {
    GetProjectAll(type, page) {

      if (type === 'diff') {
        this.pagination.page += page;
      } else if (type === 'page') {
        this.pagination.page = page;
      } else {
        this.pagination.page = 0;
      }

      this.inputPage = this.pagination.page + 1;

      this.$api
        .get('report/project-task-count', {
          params: {
            'page': this.pagination.page,
            'perPage': this.pagination.range,
          }
        })
        .then(response => {
          this.projectDataList = response.data.data;
          this.pagination.count = response.data.totalCount;
        });
    },
  }
}
</script>
